module.exports = __webpack_public_path__ + "img/sprint-empty-done.6886758f.svg";